import { createSlice } from '@reduxjs/toolkit';
import { fetchUser } from '../thunks/user';

const initialState = {
  user: {},
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchUser.pending]: (state) => {
      state.fetching = true;
    },
    [fetchUser.fulfilled]: (state, action) => {
      state.fetching = false;
      state.user = action.payload;
    },
    [fetchUser.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
  },
});
